// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1AZeN","inputWrap":"styles_inputWrap__39QM6","input":"styles_input__1DzzR"};